function capitalize(value) {
  return value[0]?.toUpperCase() + value.slice(1);
}

function clamp(value, floor, ceiling) {
  return Math.min(ceiling, Math.max(floor, value));
}

function isDefined(value) {
  return value !== null && value !== void 0;
}

export { capitalize, clamp, isDefined };
//# sourceMappingURL=index.mjs.map
